import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ButtonComp from "./ButtonComp";
import TickCircle from "../../assets/images/public-pages/green-tick-circle.png"
import ReactHtmlParser from 'react-html-parser';

export default function TestSection({ data = null, bgColor,btnImg ,extraClass=""}) {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  // Safe access — won't crash if data is null/empty/missing tabs
  const activeData = data?.tabs?.[activeTab]?.content;

  return (
    <div className="test-section py-5" style={{ "--section-bg": bgColor || "#080F1E" }}>
      <div className="custom-container text-center">

        {/* TITLE */}
        <h3 className="main-title FS40FW600">
          {ReactHtmlParser(data?.title)}{" "}
          <span className="text-success FS40FW600">{ReactHtmlParser(data?.highlight)}</span>{" "}
          <br />
         {ReactHtmlParser(data?.subtitle || '')}
        </h3>
       {data?.list && data?.list?.length > 0 && (
      <ul className=" plus-sans FS20FW500 fw-400 test-section-list">
    {data.list.map((item, index) => (
      <li key={index} style={{ display: "flex", alignItems: "start", gap: "8px", textAlign:"left" }}>
        <img src={TickCircle} alt="Check" style={{ width:"20px",height:"20px",marginTop:"6px" }} /> {item}
      </li>
    ))}
    </ul>
    )}
        {/* TABS */}
        {
          data?.tabs && data?.tabs?.length > 0 && (
            <div className="tab-wrapper justify-content-center mt-4">
          {data?.tabs?.map((tab, i) => (
            <button
              key={i}
              className={`tab-btn ${i === activeTab ? "active" : ""}`}
              onClick={() => setActiveTab(i)}
            >
              <span className="me-2">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>
          )
        }
        

        {/* DESCRIPTION */}
        {data?.description && (
          <p className="FS18FW400 plus-sans mt-3">{data.description}</p>
        )}

        {/* CONTENT — only render if activeData exists */}
        {activeData && (
          <div className="row g-4 justify-content-center mt-4">

            {/* LEFT */}
            <div className="col-md-5 d-flex">
              <div className="info-card w-100 plus-sans">
                <img src="/images/web-new-images/testIcon.svg" alt="What It Tests" className="mb-2" />
                <h5 className="FS24FW500 fw-700">{activeData.leftTitle}</h5>
                <ul className="feature-list FS17FW500 fw-500">
                  {activeData.leftPoints?.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>

            {/* RIGHT */}
            <div className="col-md-5 d-flex">
              <div className="info-card w-100 plus-sans">
                <img src="/images/web-new-images/yourApprochIcon.svg" alt="Our Approach" className="mb-2" />
                <h5 className="FS24FW500 fw-700">{activeData.rightTitle}</h5>
                <ul className="feature-list FS17FW500 fw-500">
                  {activeData.rightPoints?.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>

          </div>
        )}

        {/* BOTTOM DESCRIPTION */}
        {data?.bottomDescription && (
          <div>
            <p className={`text-center FS18FW400 plus-sans mt-3 ${extraClass}`}>
              {ReactHtmlParser(data.bottomDescription)}
            </p>
          </div>
        )}

        {/* CTA */}
        {/* <button className="plus-sans FS17FW500 primary-btn mt-4" onClick={() => navigate(data.ctaLink || '/auth/register')}>{data.cta}  <img src={btnImg || "/images/web-new-images/new-dark-arrow.svg"} alt="Register Now" /></button> */}
        {/* <button
          className="plus-sans FS17FW500 primary-btn mt-4"
          onClick={() => navigate(data?.ctaLink || '/auth/register')}
        >
          {data?.cta}
          <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
        </button> */}
        <div className="mt-4 d-flex justify-content-center align-items-center">
          <ButtonComp link={`${data?.ctaLink || '/auth/register'}`} btnText={data?.cta} img={"/images/web-new-images/new-dark-arrow.svg"} />
        </div>
      </div>
    </div>
  );
}